import React, { useState, useEffect } from 'react';
import { Layout, Input, Typography, Space } from 'antd';
import { SearchOutlined, AppstoreOutlined } from '@ant-design/icons';
import { apiService } from '../../services/api';
import { SystemSettings } from '../../types';
import './Header.css';

const { Header: AntHeader } = Layout;
const { Title } = Typography;

interface HeaderProps {
  onSearch?: (value: string) => void;
}

const Header: React.FC<HeaderProps> = ({ onSearch }) => {
  const [settings, setSettings] = useState<SystemSettings | null>(null);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const response = await apiService.getSettings();
      if (response.code === 0) {
        setSettings(response.data);
      } else {
        console.error('Failed to load settings:', response.message);
      }
    } catch (error) {
      console.error('Failed to load settings:', error);
    }
  };

  const handleSearch = (value: string) => {
    if (value.trim()) {
      window.location.href = `/search/${encodeURIComponent(value.trim())}`;
    } else if (onSearch) {
      onSearch(value);
    }
  };

  return (
    <AntHeader className="app-header">
      <div className="header-content">
        {/* Logo区域 */}
        <a href="/" className="logo-section">
          <Space size="small" align="center">
            {settings?.website_icon_url ? (
              <img
                src={settings.website_icon_url}
                alt="Logo"
                className="logo-icon"
              />
            ) : (
              <AppstoreOutlined className="logo-icon-default" />
            )}
            <Title level={3} className="site-title gradient-text">
              {settings?.website_title || 'Game Box'}
            </Title>
          </Space>
        </a>

        {/* 搜索框区域 - 右对齐 */}
        <div className="search-section">
          <div className="search-wrapper">
            <Input
              placeholder="Search Games..."
              allowClear={{
                clearIcon: <span className="search-clear-icon">✕</span>
              }}
              size="large"
              className="search-input"
              prefix={<SearchOutlined className="search-prefix-icon" />}
              onPressEnter={(e) => handleSearch((e.target as HTMLInputElement).value)}
            />
          </div>
        </div>
      </div>
    </AntHeader>
  );
};

export default Header;
